import React from 'react';
import Visualisation from './Visualisation';
import LandscapingTabs from './LandscapingTabs';
import { usePublic } from 'helpers/utlities';

function Landscaping({alert}) {

  if(usePublic()){
    return <Visualisation alert={alert}/>
  }else{
    return  <LandscapingTabs alert={alert}/>
  }
}

export default Landscaping;  